<template>
  <div>
    <b-form-radio-group
      v-model="invalue"
      :options="options"
      button-variant="outline-primary"
      size="sm"
      name="radio-btn-outline"
      buttons
      @change="(v) => $emit('change', v)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: 0 },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      invalue: 0,
    }
  },
  computed: {
    level1Count() {
      if (!this.data || !this.data.length) return 0
      const { totalCount } =
        this.data.filter((item) => {
          return item.alertLevel === 1
        })[0] || {}
      return totalCount || 0
    },
    level2Count() {
      if (!this.data || !this.data.length) return 0
      const { totalCount } =
        this.data.filter((item) => {
          return item.alertLevel === 2
        })[0] || {}
      return totalCount || 0
    },
    level3Count() {
      if (!this.data || !this.data.length) return 0
      const { totalCount } =
        this.data.filter((item) => {
          return item.alertLevel === 3
        })[0] || {}
      return totalCount || 0
    },
    level1Text() {
      return `${this.$l('radio_label_invLevel1Text') || '稳定'} (${
        this.level1Count
      })`
    },
    level2Text() {
      return `${this.$l('radio_label_invLevel2Text') || '关注'} (${
        this.level2Count
      })`
    },
    level3Text() {
      return `${this.$l('radio_label_invLevel3Text') || '紧急'} (${
        this.level3Count
      })`
    },
    levelAllText() {
      return this.$l('radio_label_invLevelAllText') || '全部'
    },
    options() {
      return [
        { text: this.levelAllText, value: 0 },
        { text: this.level1Text, value: 1 },
        { text: this.level2Text, value: 2 },
        { text: this.level3Text, value: 3 },
      ]
    },
  },
  mounted() {
    this.reset()
  },
  methods: {
    reset() {
      this.invalue = this.value
    },
  },
}
</script>
